module.exports = __webpack_public_path__ + "static/img/banner02.fe4dade.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner02.jpg
// module id = NsgE
// module chunks = 1